module.exports = __webpack_public_path__ + "img/20191210161354705.f7fd5cf2.jpg";